import { ViewWithRealIndex } from "@/components/pages/common/views-hierarchy-tabs/utils/types/types";
import { viewTabMaxWidth } from "@/components/pages/common/views-hierarchy-tabs/utils/constants/constants";

//Rough calculation of tab width (approximate number)
export const estimateTabWidth = (view: ViewWithRealIndex) => {
  const textLength = view.name.length;
  const textMaxWidth = viewTabMaxWidth - 35;
  const charWidth = 7;
  const textWidth =
    textLength * charWidth > textMaxWidth
      ? textMaxWidth
      : textLength * charWidth;

  const actionsIconWidth = 24;
  const protectIconWidth = view.protection_details?.is_protected ? 18 : 0;

  const minWidth = 70;
  const padding = 8;
  const margin = 4;

  return Math.max(
    textWidth + actionsIconWidth + protectIconWidth + padding + margin,
    minWidth,
  );
};
